const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type LeadPayload = {
  name: string;
  email: string;
  message: string;
  company?: string;
  topic?: string;
  turnstileToken?: string | null;
};

export async function submitLead(payload: LeadPayload): Promise<{ success: boolean }> {
  if (!API_BASE_URL) {
    console.info('[leads] Mock lead submitted', payload);
    await new Promise((resolve) => setTimeout(resolve, 600));
    return { success: true };
  }

  const response = await fetch(`${API_BASE_URL}/v1/leads`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Lead submission failed (${response.status}): ${text}`);
  }

  return { success: true };
}
